import { useLocationContext } from "../../../contexts/LocationContext.js";
import { useContactsForLocation } from "../../../hooks/useContactsForLocation.js";
import { ContactCard } from "../../ContactCard.js";
import "react";
import { Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationInfo/Contacts/index.tsx
function ContactsList() {
	const { locationId } = useLocationContext(true);
	const { data, loading } = useContactsForLocation({ locationId });
	return /* @__PURE__ */ jsxs("div", {
		className: "relative",
		children: [/* @__PURE__ */ jsx("div", { className: "mt-3" }), loading && !data?.contacts ? /* @__PURE__ */ jsx("div", {
			className: "relative h-20",
			children: /* @__PURE__ */ jsx(Loading, {
				message: "Loading Contacts",
				overlay: true,
				size: "xl"
			})
		}) : /* @__PURE__ */ jsx("div", {
			className: "gap-y-base flex flex-col",
			children: data?.contacts?.map((contact) => /* @__PURE__ */ jsx(ContactCard, { contact }, contact.id))
		})]
	});
}
//#endregion
export { ContactsList };

//# sourceMappingURL=index.js.map